import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  CreditNoteDraft, Returnable, ReturnRequest, ReturnSettings, SalesReturn, SalesReturnSummary,
} from '../interfaces/sales/salesReturn.interface';
import { LineSerialsRequest } from '../interfaces/inventory/serial.interface';

export const SalesReturnService = {
  list: async (institutionId: string, params: { status?: string; salespersonId?: string; unassigned?: boolean } = {}): Promise<SalesReturnSummary[]> =>
    (await axios.get(ENDPOINTS.SALES_RETURN.LIST(institutionId), { params })).data,
  get: async (id: string): Promise<SalesReturn> => (await axios.get(ENDPOINTS.SALES_RETURN.GET(id))).data,
  returnable: async (challanId: string): Promise<Returnable> =>
    (await axios.get(ENDPOINTS.SALES_RETURN.RETURNABLE(challanId))).data,
  create: async (institutionId: string, dto: ReturnRequest): Promise<SalesReturn> =>
    (await axios.post(ENDPOINTS.SALES_RETURN.CREATE(institutionId), dto)).data,
  update: async (id: string, dto: ReturnRequest): Promise<SalesReturn> =>
    (await axios.put(ENDPOINTS.SALES_RETURN.UPDATE(id), dto)).data,
  /** F6b: `serials` maps return line id -> serials (picked from the challan's SOLD serials). */
  post: async (id: string, serials?: LineSerialsRequest): Promise<SalesReturn> =>
    (await axios.post(ENDPOINTS.SALES_RETURN.POST(id), serials)).data,
  cancel: async (id: string, reason: string): Promise<SalesReturn> =>
    (await axios.post(ENDPOINTS.SALES_RETURN.CANCEL(id), { reason })).data,
  creditNoteDraft: async (id: string): Promise<CreditNoteDraft> =>
    (await axios.get(ENDPOINTS.SALES_RETURN.CREDIT_NOTE_DRAFT(id))).data,
  getSettings: async (institutionId: string): Promise<ReturnSettings> =>
    (await axios.get(ENDPOINTS.SALES_RETURN.SETTINGS(institutionId))).data,
  updateSettings: async (institutionId: string, damagedGoodsAccountId: string | null): Promise<ReturnSettings> =>
    (await axios.put(ENDPOINTS.SALES_RETURN.SETTINGS(institutionId), { damagedGoodsAccountId })).data,
};
